import React from "react";
import PropTypes from "prop-types";
import { Form, Tooltip, OverlayTrigger } from "react-bootstrap"; // Import Tooltip and OverlayTrigger

const ToggleButtonWithInfo = ({
  id,
  label,
  checked,
  onChange,
  info = "",
  infoIcon = <i className="bi bi-info-circle" />,
  infoPosition = "right",
  className = "",
  fontSize = "fs-6",
}) => {
  return (
    <div className={`d-flex align-items-start ${className}`}>
      <label htmlFor={id} style={{ display: "flex", alignItems: "center" }}>
        <div className="form-check form-switch">
          <input
            className={`form-check-input ${fontSize}`}
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
          />
        </div>
        <Form.Label className="fs-6 ml-2">{label}</Form.Label>

        {info && (
          <OverlayTrigger
            placement={infoPosition}
            overlay={<Tooltip id={`tooltip-${id}`}>{info}</Tooltip>}
            className="bg-primary"
          >
            <span className="ml-2 cursor-pointer">
              {infoIcon}
            </span>
          </OverlayTrigger>
        )}
      </label>
    </div>
  );
};

ToggleButtonWithInfo.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  info: PropTypes.string,
  infoIcon: PropTypes.node,
  infoPosition: PropTypes.oneOf(["left", "right"]),
  className: PropTypes.string,
  fontSize: PropTypes.string,
};

export default ToggleButtonWithInfo;